export * from "./types.js";
export * from "./copy.js";
export { calculateAu13 } from "./calculate.js";
export { resolveAu13Reclaim, au13PeriodForDate } from "./reclaim.js";
export type { Au13ReclaimResult } from "./reclaim.js";
export {
  deriveAu13Ati,
  deriveAu13FamilyIncome,
  buildAu13InputFromComponents,
} from "./derive-income.js";
export { fy2025_26 } from "./fy2025-26.js";
// FY2026-27 — income-tests (ATI) wiring shipped, CCS thresholds/caps
// PLACEHOLDER (data gate). Intentionally NOT added to AU13_RULESETS/
// AU13_CURRENT_FY below.
export {
  fy2026_27,
  FY2026_27 as AU13_FY2026_27,
  FY2026_27_THRESHOLDS_ARE_PLACEHOLDER as AU13_FY2026_27_PLACEHOLDER,
  deriveFy2026_27FamilyIncome,
} from "./fy2026-27.js";
export type { Au13Fy2026_27ComponentInput } from "./fy2026-27.js";
export { fy2024_25 } from "./fy2024-25.js";
export {
  fy2023_24_preReform,
  fy2023_24_postReform,
  FY2023_24_REFORM_DATE,
} from "./fy2023-24.js";

import type { FinancialYear } from "../types.js";
import type { Au13RuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";
import { fy2024_25 } from "./fy2024-25.js";
import { fy2023_24_preReform, fy2023_24_postReform } from "./fy2023-24.js";

/**
 * Registry of AU-13 rule *periods*, keyed by `periodKey`. FY2023-24 has two
 * entries because the Cheaper Child Care reform split it mid-year. Historical
 * periods stay registered so backdated reclaims resolve against the rules in
 * force then.
 */
export const AU13_RULESETS: Record<string, Au13RuleSet> = {
  "2025-26": fy2025_26,
  "2024-25": fy2024_25,
  "2023-24:pre-reform": fy2023_24_preReform,
  "2023-24:post-reform": fy2023_24_postReform,
};

/**
 * Resolve the AU-13 ruleset for a financial year. For FY2023-24 (which spans
 * two periods) the default is the post-reform period — the one that covers all
 * but the first 9 days of the FY. Use a `periodKey` directly, or
 * `resolveAu13Reclaim`, when the exact care date matters.
 */
export function au13RulesFor(fy: FinancialYear | string): Au13RuleSet {
  const direct = AU13_RULESETS[fy];
  if (direct) return direct;
  if (fy === "2023-24") return fy2023_24_postReform;
  throw new Error(`no AU-13 ruleset registered for FY ${fy}`);
}

/** Most recent AU-13 ruleset — the default for live "this year" calcs. */
export const AU13_CURRENT_FY: FinancialYear = "2025-26";
